import searchReducer from "./searchReducer";

export const searchReducers = {
  search: searchReducer,
};
